import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import environmentConfig from "../../_configs/environment.config";
import { logout } from "../../redux/slices/user.slice";

const baseQuery = fetchBaseQuery({
  baseUrl: environmentConfig.API_BASE_URL,
  prepareHeaders: (headers, { getState }) => {
    headers.set("Content-Type", "application/json");
    const typedGetState = getState();
    let token = typedGetState.user.token;

    // Check for temp_token (used for first-login password change)
    const tempToken = localStorage.getItem("temp_token");
    if (tempToken) {
      token = tempToken;
    }

    if (token) {
      headers.set("authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

const customBaseQuery = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  // console.log(result, "res");
  if (result.error && result.error.status === 406) {
    // api.dispatch(logoutUser());

    return;
  } else if (result.error && result.error.status === 401) {
    api.dispatch(logout());
  }
  return result;
};

export default customBaseQuery;
